/**
 * <cart-upsell-add>
 *
 * Wraps an upsell card's "Add to bag" button and adds its variant to the cart
 * via the shared cart store. As a custom element it upgrades automatically —
 * including on cards injected at runtime (recommendations) — with no delegation
 * or per-card framework wiring.
 *
 * The store's addToCart refreshes the cart, which updates the reactive
 * `$store.cart.items`; the cart page transitions empty→filled, the recommendations
 * upsell rebuilds off the new cart, and the drawer updates — all with no reload.
 */
if (!customElements.get('cart-upsell-add')) {
  class CartUpsellAdd extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      this.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }

    onClick = async (e) => {
      e.preventDefault();
      e.stopPropagation();

      const id = this.getAttribute('data-variant-id');
      if (!id || this.button?.disabled || this.classList.contains('is-loading')) return;

      const store = window.Alpine && window.Alpine.store('cart');
      if (!store || typeof store.addToCart !== 'function') {
        console.error('Cart upsell: cart store not ready');
        return;
      }

      this.classList.add('is-loading');
      this.button?.classList.add('is-loading');

      try {
        await store.addToCart({
          id: Number(id),
          quantity: 1,
          properties: { _source: 'cart_upsell' },
        });
      } catch (err) {
        console.error('Cart upsell: add to bag failed', err);
      } finally {
        this.classList.remove('is-loading');
        this.button?.classList.remove('is-loading');
      }
    };
  }

  customElements.define('cart-upsell-add', CartUpsellAdd);
}
